import { render, staticRenderFns } from "./DeliveryFormDetailsInfo.vue?vue&type=template&id=60f9befa&scoped=true&"
import script from "./DeliveryFormDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFormDetailsInfo.vue?vue&type=style&index=0&id=60f9befa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9befa",
  null
  
)

export default component.exports